import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {baseUrl} from '../Univ.js'
function EqpGrnInvoice(props) {
    const {grn_id} = useParams();
    const [opbillData, setopbillData] = useState([]);
    const [distData, setDistData] = useState([]);
    const [viewPharmData, setViewPharmData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response1 = await axios.get(baseUrl + 'eqp-grn-invoice/' + grn_id);
                setopbillData(response1.data);
                const dis = response1.data.map(row => row.supp.id);
                const response2 = await axios.get(baseUrl + 'edit-supplier/' + dis + '/');
                setDistData(response2.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);
    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };
    return (
        <section>
            <div>
                {opbillData.map((row, index) =>
                    <div id="invoice-print">
                        <div className="table-responsive">
                            <table
                                rules="rows"
                                cellPadding="1"
                                className="text-justify mt-1 hospital-responsive-table"
                                width="100%"
                            >
                                <tr>
                                    <th className="mx-0 ps-5" rowSpan="10">
                                        <h4> Order To </h4>
                                        <font>Distributor : {row.supp.name} - {row.supp.person}</font><br></br>
                                        <font>Contact : {row.supp.mobile} </font><br></br>
                                        <font>Address : {row.supp.address} </font><br></br>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="mx-5 ps-5">
                                        <font>GRN No #:&nbsp;{row.grn_no}</font><br></br>
                                        <font>GRN Date :&nbsp;{row.grn_date}</font><br></br>
                                        <font>{row.type.charAt(0).toUpperCase() + row.type.slice(1)} Receipt</font><br></br>
                                        <font>Invoice No #:&nbsp;{row.invoice}</font><br></br>
                                        <font>Invoice Date :&nbsp;{row.inv_date}</font><br></br>
                                    </th>
                                </tr>
                            </table>
                        </div>
                        <div className="table-responsive">
                            <table border="2" rules="rows" cellpadding="3" className=" mt-4" width="100%">
                                <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                    <th align="left">S.No</th>
                                    <th align="left">Product</th>
                                    <th align="left">Packs</th>
                                    <th align="left">Qty</th>
                                    <th align="left">F Qty</th>
                                    <th align="left">Total Qty</th>
                                    <th align="left">MRP</th>
                                    <th align="left">Purchase</th>
                                    <th align="left">SGST %</th>
                                    <th align="left">CGST %</th>
                                    <th align="left">Net Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                {row.product.split(',').map((test, subIndex) => {
                                    return (
                                        <tr key={`${index}-${subIndex}`}
                                            style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            <td>{index + subIndex + 1}</td>
                                            <td><b>{row.product.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.pack.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.qty.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.fqty.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.totqty.split(',')[subIndex].trim()}</b></td>
                                            <td><b><i className="fa fa-inr"
                                                      aria-hidden="true"></i>&nbsp;{row.mrp.split(',')[subIndex].trim()}
                                            </b></td>
                                            <td><b><i className="fa fa-inr"
                                                      aria-hidden="true"></i>&nbsp;{row.pprice.split(',')[subIndex].trim()}
                                            </b></td>
                                            <td><b>{row.sgst.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.cgst.split(',')[subIndex].trim()}</b></td>
                                            <td><b><i className="fa fa-inr"
                                                      aria-hidden="true"></i>&nbsp;{row.netamount.split(',')[subIndex].trim()}
                                            </b></td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td colSpan="5"></td>
                                    <td><b>GRN <br/>Amount</b></td>
                                    <td><b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.grnamount}</b>
                                    </td>
                                    <td><b>Invoice <br/>Amount</b></td>
                                    <td><b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.invamount}</b>
                                    </td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button
                        style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                </div>
            </div>
        </section>
    );
}
export default EqpGrnInvoice;